import React from "react";
import { Redirect, NavLink } from "react-router-dom";
import Form from "./common/form";
import auth from "../services/authService";
import { signIn, confirmSignIn } from "aws-amplify/auth";

import "../css/form.css";
import "../css/login.css";
import NotFound from "./notFound";

class LoginForm extends Form {
  state = {
    data: {
      username: "",
      password: "",
      newPassword: "",
      confirmNewPassword: "",
      mfaCode: "",
    },
    mfaStatus: false,
    mfaHelp: false,
    changePassword: false,
    errors: {},
  };

  validateForm() {
    const { username, password } = this.state.data;
    return username.length > 0 && password.length > 0;
  }

  validateMFAForm() {
    const { username, password, mfaCode } = this.state.data;
    return username.length > 0 && password.length > 0 && mfaCode.length > 5;
  }

  validateCompleteSignUpFormMatch() {
    const { newPassword, confirmNewPassword } = this.state.data;
    return newPassword.length > 7 && newPassword === confirmNewPassword;
  }

  validateCompleteSignUpFormLength() {
    const { username, newPassword } = this.state.data;
    return username.length > 0 && newPassword.length > 7;
  }

  validateCompleteSignUpFormNumber() {
    const { newPassword } = this.state.data;
    return /\d/.test(newPassword);
  }

  validateCompleteSignUpFormSpecialChar() {
    const { newPassword } = this.state.data;
    return /[$&+,:;=?@#|'<>.^*()%!_-]/.test(newPassword);
  }

  validateCompleteSignUpFormUpper() {
    const { newPassword } = this.state.data;
    return /[A-Z]/.test(newPassword);
  }

  validateCompleteSignUpFormLower() {
    const { newPassword } = this.state.data;
    return /[a-z]/.test(newPassword);
  }

  doSubmit = async (event) => {
    event.preventDefault();
    const { userStatus } = this.props;
    try {
      const { data } = this.state;
      const user = await signIn({
        username: data.username,
        password: data.password,
      });
      if (
        user.nextStep?.signInStep ===
        "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED"
      ) {
        this.setState({ changePassword: true });
      } else if (
        user.nextStep?.signInStep === "CONFIRM_SIGN_IN_WITH_SMS_CODE" ||
        user.nextStep?.signInStep === "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
      ) {
        this.setState({ mfaStatus: true });
      } else if (user.isSignedIn || user.nextStep?.signInStep === "DONE") {
        // Token management is handled automatically by Amplify v6
        // localStorage.setItem("token location", "authenticated");
        userStatus();
        window.location.href = "/proposals";
      }
    } catch (e) {
      if (e.name === "PasswordResetRequiredException") {
        alert(
          e.message + ". Please use the Forgot Password link in the login page."
        );
      } else if (e.name === "NotAuthorizedException") {
        alert("Incorrect username or password. Please try again.");
      } else if (e.name === "UserNotFoundException") {
        alert("User not found. Please check your username.");
      } else {
        alert(e.message || "Login failed. Please try again.");
      }
      console.log(e);
    }
  };

  doMFASignIn = async (event) => {
    event.preventDefault();
    const { userStatus } = this.props;
    const { data } = this.state;
    try {
      // Just confirm the MFA challenge with the code - don't call signIn again
      const result = await confirmSignIn({
        challengeResponse: data.mfaCode,
      });

      if (result.isSignedIn || result.nextStep?.signInStep === "DONE") {
        // Token management is handled automatically by Amplify v6
        userStatus();
        // Redirect to proposals after successful MFA
        window.location.href = "/proposals";
      }
    } catch (ex) {
      console.log(ex);
      alert(ex.message || "MFA verification failed. Please try again.");
    }
  };

  doCompleteSignUpSubmit = async (event) => {
    event.preventDefault();
    try {
      const { data } = this.state;
      const { userStatus } = this.props;
      // Just confirm with the new password - user is already in the password change flow
      const result = await confirmSignIn({
        challengeResponse: data.newPassword,
      });

      if (result.isSignedIn) {
        // Token management is handled automatically by Amplify v6
        userStatus();
        window.location = "/proposals";
      }
    } catch (ex) {
      console.log(ex);
    }
  };

  renderLoginForm() {
    return (
      <div className="content">
        <div className="center">
          <form onSubmit={this.doSubmit} className="form-size">
            <h1>Login</h1>
            {this.renderInput(
              "username",
              "Username",
              undefined,
              "username",
              this.state.mfaStatus
            )}
            {this.renderInput(
              "password",
              "Password",
              "password",
              "current-password",
              this.state.mfaStatus
            )}
            {!this.state.mfaStatus && (
              <div>
                <button
                  style={{ width: "100%" }}
                  type={"submit"}
                  className={
                    this.validateForm()
                      ? "btn btn-primary"
                      : "btn btn-secondary"
                  }
                  disabled={!this.validateForm()}
                >
                  Login
                </button>
                <div className="dropdown-divider"></div>
                <NavLink
                  style={{ color: "white", textDecoration: "none" }}
                  to="forgot"
                >
                  Forgot Password?
                </NavLink>
                <div
                  style={{
                    bottom: "0",
                    position: "fixed",
                    marginBottom: "20px",
                  }}
                >
                  <div style={{ color: "white", marginTop: "5px" }}>
                    <strong>
                      FOR INTERNAL USE ONLY. NOT FOR USE WITH THE PUBLIC.
                    </strong>
                  </div>
                  <div style={{ color: "white", marginTop: "5px" }}>
                    Advisory Services offered through Vicus Capital, Inc., a
                    federally Registered Investment Advisor.
                  </div>
                </div>
              </div>
            )}
            {this.state.mfaStatus && (
              <div>
                {this.renderInput(
                  "mfaCode",
                  "Multi Factor Authentication Code",
                  "Text",
                  "off"
                )}
                <button
                  style={{ width: "100%" }}
                  onClick={this.doMFASignIn}
                  className={
                    this.validateMFAForm()
                      ? "btn btn-primary"
                      : "btn btn-secondary"
                  }
                  disabled={!this.validateMFAForm()}
                >
                  Login
                </button>
                <div className="dropdown-divider"></div>
                <p>Unable to login?</p>
                <p>
                  Contact Support:
                  <br />
                  (855) 558-4287
                </p>
              </div>
            )}
          </form>
        </div>
      </div>
    );
  }

  renderCompleteSignUpForm() {
    return (
      <div className="content">
        <div className="center">
          <form onSubmit={this.doCompleteSignUpSubmit} className="form-size">
            <h1>Change Password</h1>
            {this.renderInput(
              "username",
              "Username",
              undefined,
              undefined,
              true,
              undefined
            )}
            {this.renderInput(
              "newPassword",
              "Password",
              "password",
              "new-password"
            )}
            {this.renderInput(
              "confirmNewPassword",
              "Confirm Password",
              "password"
            )}
            <button
              style={{ width: "100%" }}
              type={"submit"}
              className={
                this.validateCompleteSignUpFormMatch() &&
                this.validateCompleteSignUpFormLength() &&
                this.validateCompleteSignUpFormNumber() &&
                this.validateCompleteSignUpFormSpecialChar() &&
                this.validateCompleteSignUpFormUpper() &&
                this.validateCompleteSignUpFormLower()
                  ? "btn btn-primary"
                  : "btn btn-secondary"
              }
              disabled={
                !this.validateCompleteSignUpFormMatch() &&
                !this.validateCompleteSignUpFormLength() &&
                !this.validateCompleteSignUpFormNumber() &&
                !this.validateCompleteSignUpFormSpecialChar() &&
                !this.validateCompleteSignUpFormUpper() &&
                !this.validateCompleteSignUpFormLower()
              }
            >
              login
            </button>
            <div>
              <h4 style={{ marginTop: "10px" }}>Password Requirements:</h4>
              <div>
                <span
                  className={
                    this.validateCompleteSignUpFormLength()
                      ? "dot-success"
                      : "dot-required"
                  }
                ></span>{" "}
                Requires at least a length of 8 characters
              </div>
              <div>
                <span
                  className={
                    this.validateCompleteSignUpFormNumber()
                      ? "dot-success"
                      : "dot-required"
                  }
                ></span>{" "}
                Requires at least a number
              </div>
              <div>
                <span
                  className={
                    this.validateCompleteSignUpFormLower()
                      ? "dot-success"
                      : "dot-required"
                  }
                ></span>{" "}
                Requires at least a lower case character
              </div>
              <div>
                <span
                  className={
                    this.validateCompleteSignUpFormUpper()
                      ? "dot-success"
                      : "dot-required"
                  }
                ></span>{" "}
                Requires at least an UPPER case character
              </div>
              <div>
                <span
                  className={
                    this.validateCompleteSignUpFormSpecialChar()
                      ? "dot-success"
                      : "dot-required"
                  }
                ></span>{" "}
                Requires at least a special character
              </div>
              <div>
                <span
                  className={
                    this.validateCompleteSignUpFormMatch()
                      ? "dot-success"
                      : "dot-required"
                  }
                ></span>{" "}
                Passwords match
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }

  render() {
    if (auth.getCurrentUser()) return <Redirect to="/proposals" />;
    if (process.env.NODE_ENV !== "production") {
      return (
        <React.Fragment>
          <img
            style={{
              height: "calc(100vh - 50px)",
              minWidth: "1000px",
              width: "100%",
              minHeight: "500px",
              filter: "brightness(80%)",
              position: "fixed",
              zIndex: "-1",
            }}
            src={"./Images/5.jpg"}
            alt="5.jpg"
          ></img>
          <div>
            {!this.state.changePassword && this.renderLoginForm()}
            {this.state.changePassword && this.renderCompleteSignUpForm()}
          </div>
        </React.Fragment>
      );
    } else return <NotFound />;
  }
}

export default LoginForm;
